import { render } from "./AutoRechargeBlock.vue?vue&type=template&id=3fb5b222&scoped=true"
import script from "./AutoRechargeBlock.vue?vue&type=script&lang=ts"
export * from "./AutoRechargeBlock.vue?vue&type=script&lang=ts"

import "./AutoRechargeBlock.vue?vue&type=style&index=0&id=3fb5b222&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fb5b222"

export default script